import type { FaireThemeEntity } from "../../entity_types/theme";

export const bohemian_glow_essentials: FaireThemeEntity = {
  token: "bohemian-glow-essentials",
  type: "theme",
  name: "Bohemian Glow Essentials",
  description: "Artistic and bohemian-inspired rings and necklaces that complement a fresh beauty look. These vintage-style accents add a unique touch to your current jewelry display.",
  teaser: "Based in San Jose, CA, your store's frequent orders of 'Bohemian' and 'Artistic' styled items from brands like Flânerie by MAIQ show a clear preference for this trend.",
  detail: "The payload includes several items specifically tagged with 'Bohemian' and 'Vintage' styles, such as the Virelle Knot Ring and the Ruth Adjustable Cross Ring.",
  bgColor: "#D4FFD4",
  tileBgColor: "#6b3a5b",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_ufjavmwa64",
    "p_497atqz5h5",
    "p_s5kj5vxsjg",
    "p_9cytpfywtd",
    "p_7qedgs9upw",
    "p_yjh7fym9ek",
    "p_mrdc3wmdh2",
    "p_ut3tbs6mrw",
    "p_6qkpp7ngym",
    "p_aqmjevz36r",
    "p_tt7bwx4gz3",
    "p_cva2y6pxqf",
    "p_7aj8n8fwkr",
    "p_ykcapkuvqq",
    "p_y4nj9hy2yr",
    "p_85zuvdfqvw",
    "p_zbfwgazcex",
    "p_zy2dxdupqx",
    "p_9pm84vbjg7",
    "p_5n8nj76687",
    "p_495zgeetkv",
    "p_bagjhpjgk4",
    "p_kdrhy6cpqq",
    "p_rrpf769599",
    "p_q5gsng2er3",
    "p_ar6ja253qt",
    "p_5gefr7p29d",
    "p_nrg5hxcuy3",
    "p_ucy6vyhj6v",
    "p_seuspqr253",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
